import { Component } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-recaptcha',
  template: ` <re-captcha
      (resolved)="resolved($event)"
      [siteKey]="field.templateOptions?.siteKey"
      [formControl]="control"
      [formlyAttributes]="field"
    >
    </re-captcha>
    <pre></pre>`,
  standalone: false,
})
export class FormlyRecaptchaComponent extends FieldType {
  control: UntypedFormControl;

  field: FormlyFieldConfig;

  resolved(captchaResponse: string) {
    // todo: set validated true;
    this.field.formControl?.setValue(captchaResponse);
  }
}
